import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import IconSubtask from '../icons/icon-subtask';
import IconFile from '../icons/icon-file';
import IconDiscussionAlt from '../icons/icon-discussion-alt';
import IconCustomField from '../icons/icon-custom-field';

const NavItem = ({ id, label, icon, current, hideOnLarge, onClick }) => {
    const handleClick = () => onClick(id);

    return (
        <div className={'horizontal-nav-item' + (current === id ? ' active' : '') + (hideOnLarge ? ' hide-on-large' : '')} data-text={label} onClick={handleClick}>
            <div className="horizontal-nav-item-icon">
                {icon}
            </div>

            {label}
        </div>
    )
}

class TaskNav extends PureComponent {
    render() {
        const { t } = this.props;

        return (
            <div className="horizontal-nav content-panel-nav">
                <NavItem id="subtasks" label={ t('task:Subtasks') } icon={<IconSubtask />} current={this.props.current} onClick={this.props.onClick} />

                {
                    !this.props.public ? (
                        <React.Fragment>
                            <NavItem id="files" label={ t('Attachments') } icon={<IconFile />} current={this.props.current} onClick={this.props.onClick} />

                            <NavItem id="fields" label={ t('fields:Custom Fields') } icon={<IconCustomField />} current={this.props.current} onClick={this.props.onClick} />

                            <NavItem id="comments" label={ t('Comments') } hideOnLarge={true} icon={<IconDiscussionAlt />} current={this.props.current} onClick={this.props.onClick} />
                        </React.Fragment>
                    ) : null
                }
            </div>
        )
    }
}

export default withTranslation(['common', 'task', 'fields'])(TaskNav);
